export default {"src":"/_next/static/media/ic_new_wallet_v2.a0a93f6a.svg","height":178,"width":180,"blurWidth":0,"blurHeight":0};